export const initialState = {
    headerTitle: '',
    proceedBtnDisabled: false,
    isPageMultiSelect: false,
    retrievedProducts: [],
}
export const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_HEADER_TITLE':
            return {...state, headerTitle: action.payload}
        case 'SET_PROCEED_BTN_DISABLED':
            return {...state, proceedBtnDisabled: action.payload}
        case 'SET_IS_PAGE_MULTI_SELECT':
            return {...state, isPageMultiSelect: action.payload}
        case 'SET_RETRIEVED_PRODUCTS':
            return {...state, retrievedProducts: action.payload}
        case 'SET_RENDER_PAGE':
            return {...state, ...action.payload}
        default:
            return state
    }
}
